import "bootstrap/dist/css/bootstrap.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import axios from "axios";
import { baseUrl } from "../Components/baseUrl";
import { toast } from "react-toastify";
import Menu from "../Components/Menu";

const Reports = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "ویزیت | گزارشات";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [activeTab, setActiveTab] = useState(1);
    let optionsDayly = {
        chart: {
            type: "bar",
        },
        series: [
            {
                name: "sales",
                data: [200000, 200000, 300000, 400000, 300000, 500000, 600000],
            },
        ],
        plotOptions: {
            bar: {
                borderRadius: 23,
            },
        },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    plotOptions: {
                        bar: {
                            borderRadius: 14,
                        },
                    },
                },
            },
            {
                breakpoint: 600,
                options: {
                    chart: {
                        width: 450,
                        height: 450,
                    },
                },
            },
            {
                breakpoint: 450,
                options: {
                    chart: {
                        width: 350,
                    },
                },
            },
        ],
        xaxis: {
            categories: [
                "سفارش جدید",
                "ارسال به انبار",
                "ارسال به مشتری",
                "تایید شده",
                "مرجوعی",
                "برگشتی",
                "کنسل شده",
            ],
        },
        fill: {
            colors: ["#F44336"],
        },
    };
    let optionsMonthly = {
        chart: {
            type: "bar",
        },
        plotOptions: {
            bar: {
                borderRadius: 23,
            },
        },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    plotOptions: {
                        bar: {
                            borderRadius: 14,
                        },
                    },
                },
            },
            {
                breakpoint: 600,
                options: {
                    chart: {
                        width: 450,
                        height: 450,
                    },
                },
            },
            {
                breakpoint: 450,
                options: {
                    chart: {
                        width: 350,
                    },
                },
            },
        ],
        xaxis: {
            categories: [
                "سفارش جدید",
                "ارسال به انبار",
                "ارسال به مشتری",
                "تایید شده",
                "مرجوعی",
                "برگشتی",
                "کنسل شده",
            ],
        },
        fill: {
            colors: ["#80C0FB"],
        },
    };
    let optionsYearly = {
        chart: {
            type: "bar",
        },
        series: [
            {
                name: "sales",
                data: [500000, 100000, 300000, 400000, 400000, 200000, 600000],
            },
        ],
        plotOptions: {
            bar: {
                borderRadius: 23,
            },
        },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    plotOptions: {
                        bar: {
                            borderRadius: 14,
                        },
                    },
                },
            },
            {
                breakpoint: 600,
                options: {
                    chart: {
                        width: 450,
                        height: 450,
                    },
                },
            },
            {
                breakpoint: 450,
                options: {
                    chart: {
                        width: 350,
                    },
                },
            },
        ],
        xaxis: {
            categories: [
                "سفارش جدید",
                "ارسال به انبار",
                "ارسال به مشتری",
                "تایید شده",
                "مرجوعی",
                "برگشتی",
                "کنسل شده",
            ],
        },
        fill: {
            colors: ["#82FB80"],
        },
    };

    const [weekData, setWeekData] = useState([]);
    const [weekTableData, setWeekTableData] = useState([]);
    let today = new Intl.DateTimeFormat("fa-u-ca-persian-nu-latn", {}).format(
        new Date()
    );
    let lastWeek = new Intl.DateTimeFormat(
        "fa-u-ca-persian-nu-latn",
        {}
    ).format(new Date().setDate(new Date().getDate() - 7));

    useEffect(() => {
        let config = {
            url: `${baseUrl}/report?period=day&start=${lastWeek}&end=${today}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res.data &&
                    res.data.data &&
                    setWeekTableData(res.data.data.saleReport);
                const apiData = res.data.data.statusReport;
                const categories = [
                    "سفارش جدید",
                    "ارسال به انبار",
                    "ارسال به مشتری",
                    "تایید شده",
                    "مرجوعی",
                    "برگشتی",
                    "کنسل شده",
                ];
                const series = [
                    {
                        name: "data",
                        data: [
                            apiData.new,
                            apiData.warehouse,
                            apiData.posted,
                            apiData.confirmed,
                            apiData.recovered,
                            apiData.returned,
                            apiData.canceled,
                        ],
                    },
                ];
                setWeekData({
                    series: series,
                });
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [monthData, setMonthData] = useState([]);
    const [monthTableData, setMonthTableData] = useState([]);
    useEffect(() => {
        let config = {
            url: `${baseUrl}/report?period=month`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setMonthData(res.data.data);
                setMonthTableData(res.data.data.saleReport);

                const apiData = res.data.data.statusReport;
                const categories = [
                    "سفارش جدید",
                    "ارسال به انبار",
                    "ارسال به مشتری",
                    "تایید شده",
                    "مرجوعی",
                    "برگشتی",
                    "کنسل شده",
                ];
                const series = [
                    {
                        name: "data",
                        data: [
                            apiData.new,
                            apiData.warehouse,
                            apiData.posted,
                            apiData.confirmed,
                            apiData.recovered,
                            apiData.returned,
                            apiData.canceled,
                        ],
                    },
                ];
                setMonthData({
                    series: series,
                });
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [yearData, setYearData] = useState([]);
    const [yearTableData, setYearTableData] = useState([]);
    useEffect(() => {
        let config = {
            url: `${baseUrl}/report?period=year`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setYearData(res.data.data);
                setYearTableData(res.data.data.saleReport);
                const apiData = res.data.data.statusReport;
                const categories = [
                    "سفارش جدید",
                    "ارسال به انبار",
                    "ارسال به مشتری",
                    "تایید شده",
                    "مرجوعی",
                    "برگشتی",
                    "کنسل شده",
                ];
                const series = [
                    {
                        name: "data",
                        data: [
                            apiData.new,
                            apiData.warehouse,
                            apiData.posted,
                            apiData.confirmed,
                            apiData.recovered,
                            apiData.returned,
                            apiData.canceled,
                        ],
                    },
                ];
                setYearData({
                    series: series,
                });
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    return (
        <div>
            <div className="container">
                <div className="reports-main">
                    <a onClick={() => navigate("/panel/setting")}>
                        <svg
                            className="back"
                            width="15"
                            height="26"
                            viewBox="0 0 15 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13.5 1L2.20711 12.2929C1.81658 12.6834 1.81658 13.3166 2.20711 13.7071L13.5 25"
                                stroke="black"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                    <h6>گزارشات</h6>
                    <div className="tabs">
                        <div
                            onClick={() => setActiveTab(1)}
                            className={activeTab == 1 ? "tab active" : "tab"}
                        >
                            گزارش روزانه
                        </div>
                        <div
                            onClick={() => setActiveTab(2)}
                            className={activeTab == 2 ? "tab active" : "tab"}
                        >
                            گزارش ماهانه
                        </div>
                        <div
                            onClick={() => setActiveTab(3)}
                            className={activeTab == 3 ? "tab active" : "tab"}
                        >
                            گزارش سالانه
                        </div>
                    </div>
                    {activeTab == 1 && optionsDayly && weekData.series ? (
                        <Chart
                            className="chart"
                            options={optionsDayly}
                            series={weekData.series}
                            type="bar"
                            width="500"
                        />
                    ) : activeTab == 2 && optionsMonthly && monthData.series ? (
                        <Chart
                            className="chart"
                            options={optionsMonthly}
                            series={monthData.series}
                            type="bar"
                            width="500"
                        />
                    ) : activeTab == 3 && optionsYearly && yearData.series ? (
                        <Chart
                            className="chart"
                            options={optionsYearly}
                            series={yearData.series}
                            type="bar"
                            width="500"
                        />
                    ) : (
                        ""
                    )}
                    <div className="days-box">
                        {activeTab == 1
                            ? weekTableData &&
                              weekTableData.length !== 0 &&
                              weekTableData.map((item) => {
                                  return (
                                      <>
                                          <hr />
                                          <div className="report-table-row">
                                              <span>{item.period} : </span>
                                              <span className="span-2">
                                                  {Number(
                                                      item.total
                                                  ).toLocaleString()}{" "}
                                                  تومان
                                              </span>
                                          </div>
                                      </>
                                  );
                              })
                            : activeTab == 2
                            ? monthTableData &&
                              monthTableData.length !== 0 &&
                              monthTableData.map((item) => {
                                  return (
                                      <>
                                          <hr />
                                          <div className="report-table-row">
                                              <span>{item.period} : </span>
                                              <span className="span-2">
                                                  {Number(
                                                      item.total
                                                  ).toLocaleString()}{" "}
                                                  تومان
                                              </span>
                                          </div>
                                      </>
                                  );
                              })
                            : yearTableData &&
                              yearTableData.length !== 0 &&
                              yearTableData.map((item) => {
                                  return (
                                      <>
                                          <hr />
                                          <div className="report-table-row">
                                              <span>{item.period} : </span>
                                              <span className="span-2">
                                                  {Number(
                                                      item.total
                                                  ).toLocaleString()}{" "}
                                                  تومان
                                              </span>
                                          </div>
                                      </>
                                  );
                              })}

                        {/* <hr />
                        <span>سفارش جدید:</span>
                        <hr />
                        <span>ارسال به انبار:</span>
                        <hr />
                        <span>ارسال به مشتری:</span>
                        <hr />
                        <span>تایید شده:</span>
                        <hr />
                        <span>مرجوعی:</span>
                        <hr />
                        <span>برگشتی:</span>
                        <hr />
                        <span>کنسل شده:</span>
                        <hr /> */}
                    </div>
                </div>
                <Menu active="setting" />
            </div>
        </div>
    );
};

export default Reports;
